import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-5"
}
const _hoisted_2 = { class: "container mx-auto my-5" }
const _hoisted_3 = ["initial", "enter"]
const _hoisted_4 = { class: "bg-white shadow-md p-6 rounded-md border-b-4 border-h-primary-500" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "text-justify mt-4" }
const _hoisted_7 = ["initial", "enter"]
const _hoisted_8 = ["initial", "enter"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["initial", "enter"]
const _hoisted_11 = { class: "flex flex-row space-x-4" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = { class: "text-gray-400 text-[12px]" }
const _hoisted_15 = {
  key: 0,
  class: "text-gray-400 text-[12px]"
}
const _hoisted_16 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "flex mt-8 justify-start items-start gap-3" }
const _hoisted_19 = {
  key: 0,
  class: "border border-h-primary-500 bg-h-primary-100 p-1 rounded-md hover:scale-95 transition-all",
  disabled: true
}
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 1,
  class: "border border-h-primary-500 bg-h-primary-100 p-1 rounded-md hover:scale-95 transition-all",
  disabled: true
}
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 2,
  class: "border border-h-primary-500 bg-h-primary-100 p-1 rounded-md hover:scale-95 transition-all",
  disabled: true
}
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _directive_motion = _resolveDirective("motion")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.course)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _withDirectives(_createVNode(_component_Hero, {
          course: _ctx.course,
          initial: _ctx.initialMotion,
          enter: _ctx.enterMotion
        }, null, 8, ["course", "initial", "enter"]), [
          [_directive_motion]
        ]),
        _createElementVNode("section", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            id: "description",
            class: "space-y-4 sm:p-0 p-4",
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion.getEnterMotion(100)
          }, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Resumo do curso",
              en: "Summary from course",
            })), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", { pt: "Duração: ", en: "Duration: " })), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.generics.getDurationTime(Number(_ctx.course.duration))), 1)
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.course.description), 1)
            ])
          ], 8, _hoisted_3)), [
            [_directive_motion]
          ]),
          (_ctx.course?.summary)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 0,
                id: "summary",
                class: "space-y-4 sm:p-0 p-4 mt-5",
                initial: _ctx.initialMotion,
                enter: _ctx.enterMotion.getEnterMotion(200)
              }, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Ementa do curso",
              en: "Course program",
            })), 1),
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "bg-white shadow-md p-6 rounded-md border-b-4 border-h-primary-500",
                  initial: _ctx.initialMotion,
                  enter: _ctx.enterMotion.getEnterMotion(300)
                }, [
                  _createElementVNode("p", {
                    class: "text-justify",
                    innerHTML: _ctx.course?.summary
                  }, null, 8, _hoisted_9)
                ], 8, _hoisted_8)), [
                  [_directive_motion]
                ])
              ], 8, _hoisted_7)), [
                [_directive_motion]
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            id: "teacher-profile",
            initial: _ctx.initialMotion,
            enter: _ctx.enterMotion.getEnterMotion(400),
            class: "mt-10 bg-white shadow-md p-6 rounded-md border-b-4 border-h-primary-500"
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _ctx.course.teacher.photoProfile?.path || _ctx.emptyImg,
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
                alt: "profile-teacher",
                class: "w-20 h-fit bg-center bg-cover rounded-md"
              }, null, 40, _hoisted_12),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("labels.generic", { pt: "Instrutor(a)", en: "Instructor" })), 1),
                _createElementVNode("h5", null, _toDisplayString(_ctx.course.teacher?.name), 1),
                (_ctx.course.teacher?.teacherProfile?.title)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.course.teacher?.teacherProfile?.title), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.course.teacher?.teacherProfile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.course.teacher?.teacherProfile?.description
                  }, null, 8, _hoisted_17),
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.course.teacher?.teacherProfile?.generalUrl)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_19, [
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            href: _ctx.course.teacher?.teacherProfile?.generalUrl,
                            target: "_blank"
                          }, [
                            _createVNode(_component_v_icon, {
                              name: "hi-globe-alt",
                              class: "text-primary-400"
                            })
                          ], 8, _hoisted_20)), [
                            [
                              _directive_tooltip,
                              'Site',
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.course.teacher?.teacherProfile?.lattesUrl)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_21, [
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            href: _ctx.course.teacher?.teacherProfile?.lattesUrl,
                            target: "_blank"
                          }, [
                            _createVNode(_component_v_icon, {
                              name: "ai-lattes",
                              class: "text-primary-400"
                            })
                          ], 8, _hoisted_22)), [
                            [
                              _directive_tooltip,
                              'Lattes',
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.course.teacher?.teacherProfile?.linkedinUrl)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_23, [
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            href: _ctx.course.teacher?.teacherProfile?.linkedinUrl,
                            target: "_blank"
                          }, [
                            _createVNode(_component_v_icon, {
                              name: "co-linkedin-in",
                              class: "text-primary-400"
                            })
                          ], 8, _hoisted_24)), [
                            [
                              _directive_tooltip,
                              'Linkedin',
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_10)), [
            [_directive_motion]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}